import React from 'react';
import { useForm, Resolver } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { TextField } from '@mui/material';
import { Link, Box } from '@bighealth/react-limbix-ui';
import * as yup from 'yup';

import Styled from './Login.styles';

import { ErrorMessage } from '@/components';
import { LoginFormType, LoginFields } from '@/types';

type Props = {
  onSubmit: (formData: LoginFormType) => Promise<void>;
  errorMessage?: string;
};

const formSchema = yup.object({
  [LoginFields.EMAIL]: yup
    .string()
    .email('Invalid email format')
    .max(254, 'Email must be at most 254 characters long')
    .trim()
    .required('Email is required'),
  [LoginFields.PASSWORD]: yup
    .string()
    .required('Password is required'),
});

function Login(props : Props) {
  const { onSubmit, errorMessage } = props;
  const { register, handleSubmit, formState: { errors } } = useForm<LoginFormType>({
    resolver: yupResolver(formSchema) as Resolver<LoginFormType>,
    mode: 'onChange',
  });
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TextField
        variant="outlined"
        margin="normal"
        type="text"
        fullWidth
        autoFocus
        required
        autoCapitalize="none"
        label="Email Address"
        id={LoginFields.EMAIL}
        {...register(LoginFields.EMAIL)}
        error={!!errors.email}
        helperText={errors.email?.message}
      />
      <TextField
        variant="outlined"
        margin="normal"
        type="password"
        fullWidth
        required
        label="Password"
        id={LoginFields.PASSWORD}
        {...register(LoginFields.PASSWORD, { required: true })}
        error={!!errors.password?.message}
        helperText={errors.password?.message}
      />
      <Link.RouterLink to="/reset-password" underlined>
        Forgot password?
      </Link.RouterLink>
      <Styled.SubmitButton
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
      >
        Sign in
      </Styled.SubmitButton>
      <Box textAlign="center">
        <ErrorMessage message={errorMessage} />
      </Box>
      <Box marginTop="16px">
        If you&apos;ve forgotten or changed your email address, please email
        {' '}
        <a href="mailto:clinic@bighealth.com">clinic@bighealth.com</a>
      </Box>
    </form>
  );
}

export default Login;
